var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-settings__section" }, [
    _c("div", { staticClass: "t-settings__heading" }, [
      _c("div", { staticClass: "t-settings__left t-fs--subtitle" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("player.permission_settings.link.title")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "t-settings__right" }, [
        _c(
          "a",
          {
            staticClass: "t-link t-fs--body",
            on: {
              click: function($event) {
                return _vm.copyLinkCode()
              }
            }
          },
          [
            !_vm.linkCopyingInProgress
              ? [
                  _c("i", { staticClass: "fas fa-link t-mar--r-ti" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("generic.link.copy")))])
                ]
              : [_vm._v(_vm._s(_vm.$t("generic.link.copied")))]
          ],
          2
        ),
        _vm._v(" "),
        _c("span", { staticClass: "t-fs--body t-tc--muted" }, [_vm._v("|")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "t-link t-fs--body",
            attrs: {
              href:
                _vm.type == "collection"
                  ? _vm.collectionShareableLink
                  : _vm.videoShareableLink,
              target: "_blank"
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("generic.link.open")))]),
            _c("i", {
              staticClass: "fas fa-external-link-alt t-mar--l-ti t-fs--caption"
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "t-settings__caption t-tc--muted t-mar--t-ti" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("player.permission_settings.link.description")) +
          "\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }